import React from 'react';
import classes from './Button.module.css';

const Button = (props) => {
    let classesList = [classes.Button, classes[props.type]];
    if(props.disabled){
        classesList.push(classes.fade);
    }
    return (
    <button onClick={props.clicked}
    className={classesList.join(' ')}
    disabled={props.disabled}>{props.children}</button>);
}

export default Button;